import EditFormGroup from "components/form/EditFormGroup";
import { forwardRef } from "react";

export default forwardRef(function CreatePieOfTheMonthForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "name",
            label: "Month",
            type: "text",
            size: "small",
            itemSize: { lg: 6, md: 6, sm: 8, xs: 12 },
          },
          {
            name: "alert",
            label: "Announcement Bar",
            type: "text",
            size: "small",
            itemSize: { lg: 12, md: 12, sm: 12, xs: 12 },
          },
        ]}
        isLabel
        fullWidth={true}
        alignItems="flex-end"
        direction="row"
        spacing={2}
      />
    </div>
  );
});
